import type { ReactNode } from 'react';

interface PrimaryProps {
  children: ReactNode;
  onClick?: () => void;
  gold?: boolean;
  disabled?: boolean;
}

export function PrimaryButton({ children, onClick, gold, disabled }: PrimaryProps) {
  return (
    <button
      type="button"
      className={'gb-btn ' + (gold ? 'gb-btn--gold' : 'gb-btn--primary')}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

export function SecondaryButton({ children, onClick }: { children: ReactNode; onClick?: () => void }) {
  return (
    <button type="button" className="gb-btn gb-btn--secondary" onClick={onClick}>
      {children}
    </button>
  );
}
